<template>
  <div>
    <v-row no-gutters justify="start" align="center">
      <v-avatar color="primary" size="40" class="mr-3">
        <span class="white--text">FB</span>
      </v-avatar>
      <div>
        <div class="font-weight-medium">
          {{ note.user.firstname }} {{ note.user.lastname }}
        </div>
        <div class="text-caption">
          Le {{ note.createdAt | formatDate }} à {{ note.createdAt | formatHour }}
        </div>
      </div>
    </v-row>
    <div class="pt-2" style="padding-left: 40px;">
      <n-card class="pa-3 ml-3">
        <div v-html="htmlNote"></div>
      </n-card>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    note: {
      type: Object,
      required: true,
    },
  },

  computed: {
    htmlNote() {
      return this.note.note.replace(/\r\n|\r|\n/g, `<br />`);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
